import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { global } from '../../shared/global';
import { Login } from '../Models/login.model';
import { NgForm } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from '../login/login.service';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild('loginForm', { static: true }) loginForm: NgForm;
  @ViewChild('verify', { static: true }) verifyInput: ElementRef;

  termConditionLink: any;
  data: Login;
  cookieValue: any;
  responseData: any;
  mobileNumber: any;
  errorMessage: any;
  pincodeList: Array<any> = [];

  constructor(private router: Router, private cookieService: CookieService, private spinner: NgxSpinnerService, private service: LoginService) {
  }

  ngOnInit() {
    this.spinner.hide();
    document.getElementById("divVerify").style.display = "none";

    this.data = new Login();
    this.termConditionLink = global.termConditionLink;

    this.cookieValue = this.cookieService.get("login");
    if (this.cookieValue) {
      // this.router.navigate(["/customer"]);
      this.router.navigate(["/welcome"]);
    }
  }

  onSubmit(login: Login) {
    if (this.loginForm.valid) {
      var objData = {
        "action": "sendotp",
        "mobile": login.mobile
      }

      this.spinner.show();
      this.service.sendVerifyOTP(objData)
        .subscribe(otpData => {
          this.responseData = otpData;

          if (this.responseData.isSuccess == false) {
            this.spinner.hide();
          }
          else {
            this.spinner.hide();
            // this.cookieService.set("login", JSON.stringify(this.data));
            this.mobileNumber = login.mobile;
            $('#verifyOTPModal').modal('show');
          }
        });
    } else {
    }
  }

  cancelOTP() {
    // this.loginForm.resetForm();
    this.cookieService.delete("login");
    $('#verifyOTPModal').modal('hide');
    document.getElementById("divVerify").style.display = "none";
    this.verifyInput.nativeElement.value = "";
  }

  verifyOTP() {
    if (this.verifyInput.nativeElement.value) {
      var objData = {
        "action": "verifyotp",
        "mobile": this.mobileNumber,
        "otp": this.verifyInput.nativeElement.value
      }

      this.spinner.show();
      this.service.sendVerifyOTP(objData)
        .subscribe(otpData => {
          this.responseData = otpData;

          if (this.responseData.isSuccess == false) {
            this.spinner.hide();
            document.getElementById("divVerify").style.display = "block";
            this.errorMessage = this.responseData.message;
          }
          else {
            document.getElementById("divVerify").style.display = "none";
            $('#verifyOTPModal').modal('hide');
            this.verifyInput.nativeElement.value = "";
            this.cookieService.set("login", JSON.stringify(this.data));

            var objPincode = {
              "pincode": this.data.pincode,
              "selected": 1
            };
            this.pincodeList.push(objPincode);
  
            this.cookieService.set("pincodes", JSON.stringify(this.pincodeList));

            // this.router.navigate(["/customer"]);
            this.router.navigate(["/welcome"]);
          }
        });
    } else {
      document.getElementById("divVerify").style.display = "block";
      this.errorMessage = "OTP is required";
    }
  }

  resendOTP() {
    if (this.mobileNumber) {
      var objData = {
        "action": "sendotp",
        "mobile": this.mobileNumber,
      }

      this.spinner.show();
      this.service.sendVerifyOTP(objData)
        .subscribe(otpData => {
          this.responseData = otpData;

          if (this.responseData.isSuccess == false) {
            this.spinner.hide();
          }
          else {
            this.spinner.hide();
          }
        });
    }
  }
}
